export default "__VITE_ASSET__daa0f320__"